import {RepositoryFactory} from '@/repository/RepositoryFactory';
const CustomerRepository = RepositoryFactory.get('customer');
const SupplierRepository = RepositoryFactory.get('supplier');
const StaffRepository = RepositoryFactory.get('staff');

export default {
  state: {
    customers: [],
    countries: [],
    suppliers: [],
    staffs: [],
    industry_sectors: [],
  },
  mutations: {
    SET_CUSTOMERS: (state, customers) => (state.customers = customers),
    SET_COUNTRIES: (state, countries) => (state.countries = countries),
    SET_SUPPLIERS: (state, suppliers) => (state.suppliers = suppliers),
    SET_STAFFS: (state, staffs) => (state.staffs = staffs),
    SET_INDUSTRY_SECTORS: (state, industry_sectors) => (state.industry_sectors = industry_sectors),
  },
  getters: {
    customers: state => state.customers,
    countries: state => state.countries,
    suppliers: state => state.suppliers,
    staffs: state => state.staffs,
    industry_sectors: state => state.industry_sectors,
  },
  actions: {
    async fetchCustomers ({commit, state}) {
      if(state.customers.length === 0) {
        const {data} = (await CustomerRepository.get(1, '', 150, '')).data
        commit('SET_CUSTOMERS', data.map((x) => ({ name: x.company_name, value: x.id })));
      }
    },
    async fetchSuppliers ({commit, state}) {
      if(state.suppliers.length === 0) {
        const {data} = (await SupplierRepository.get(1, '', 150, '')).data
        commit('SET_SUPPLIERS', data.map((x) => ({ name: x.company_name, value: x.id })));
      }
    },
    async fetchCountries ({commit, state}) {
      if(state.countries.length === 0) {
        const {data} = (await CustomerRepository.getCountryCodes()).data
        commit('SET_COUNTRIES', data.map((x) => ({ name: x.name, value: x.id })));
      }
    },
    async fetchStaffs ({commit, state}) {
      if(state.staffs.length === 0) {
        const {data} = (await StaffRepository.get(1, '', 150, '')).data
        commit('SET_STAFFS', data.map((x) => ({ name: x.name, value: x.id })));
      }
    },
    async fetchIndustrySections ({commit, state}) {
      if(state.industry_sectors.length === 0) {
        const {data} = (await CustomerRepository.getIndustrySectors('')).data
        commit('SET_INDUSTRY_SECTORS', data.map((x) => ({ name: x.name, value: x.id })));
      }
    },
  }
}
